import { IThemeProps } from 'component/theme';
import styled from 'styled-components';

export interface ISelectBoxProps extends IThemeProps {
  isInput?: boolean;
  isSelectEnv?: boolean;
}

export const SelectBoxWrapper = styled.div<ISelectBoxProps>`
  ${({ theme, isInput, isSelectEnv }) => `
    ${
      !isSelectEnv
        ? `display: flex;
        align-items: center;
        width: fit-content;
        border-radius: 32px;
        border: 2px solid #ccc;
        padding: 8px 20px;
        background-color: #fff;`
        : ''
    }
    .MuiInput-underline {
      &:before {
        border-bottom: none !important;
      }
      &:after {
        border-color: ${theme.uptimeColors.mainTheme.primary} !important;
      }
    }

    .MuiSelect-icon {
      top: calc(50% - 14px);
    }

    .MuiFormControl-root {
      display: flex;
      flex-direction: row;
      align-items: baseline;
    }

    .MuiInputBase-root {
      margin-left: 6px;
      font-weight: 600;
      ${isInput ? 'width: 120px;' : ''}
    }
  `}
`;
